import React, { useEffect, useRef, useState } from "react";
import { Definition } from "../../../../../../data/Definition";
import Stats from "../../../../components/Elements/StatsPlotly";
import Widget from "../../../../components/Elements/Widget";
import { useStore } from "../../../../providers/AppProvider";
import { Field, StatValue } from "../../../../types/types";
import { queryDwMetric } from "../../../../utils/dwHelpers";
import { SETTING_SEASON_YEAR } from "../../../../utils/settings";

const CACHE_SIZE = 20;

interface DwFieldStatWidgetProps {
    field: Field;
    name: string;
    description: string;
    metric: 'productivity' | 'stress';
    changeInverted?: boolean;
    dateSelected: string | null;
}

const DwFieldStatWidget = ({ dateSelected, field, name, description, metric, changeInverted=false }: DwFieldStatWidgetProps) => {
    const { state, loading, settings } = useStore();

    const [data, setData] = useState<StatValue | null>(null);
    const [rawData, setRawData] = useState<any | null>(null);
    const [dataLoading, setDataLoading] = useState<boolean>(false);

    const { current: cache} = useRef({});

    useEffect(() => {
        if(loading || !field) {
            return;
        }

        const definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('field'));

        if(!definition) {
            console.error('Unable to find field definition');
            return;
        }

        const key = [field.ext_id!, settings[SETTING_SEASON_YEAR], metric].join("_");
        
        const fetchData = async () => {
            console.log("E121124 field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition",field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition)
            const result = await _load(field.ext_id!, settings[SETTING_SEASON_YEAR], metric, definition);
            console.log("E121124 setData(result", result)
            setData(result);
            setRawData(result ? {
                "data": result.raw ? result.raw : null,
            } : null);
            setDataLoading(false);
            if (result) {
                result.field_id = field.ext_id;
            }
            cache[key] = result;
        };

        console.log("A070124 field", field);
        console.log("A070124 key", key);
        console.log("A070124 cache", cache)
        if(!cache.hasOwnProperty(key)) {
            console.log("070124 A cache", cache)
            fetchData();
        } else {
            console.log("070124 B cache", cache)
            if (cache[key] && cache[key].field_id !== field.ext_id) {
                console.log("070124 C cache", cache)
                fetchData();
            }else{
                console.log("B070124 setData(cache[key]", cache[key])
                console.log("A070124 key", key)
                setData(cache[key]);
                setRawData({
                    "data": cache[key] ? (cache[key].raw ? cache[key].raw : null) : null,
                });
            }
        }

    }, [loading, field, metric]);

    const _load = async (extId: number, year: number, metric: string, definition: Definition) => {
        const dtStart = `${year}-01-01 12:00:00.00`;
        const dtEnd = `${year}-12-31 23:59:59.59`;

        const data = await queryDwMetric(extId, definition, metric, dtStart, dtEnd);
        console.log("E121124 data", data)
        setRawData({
            "data": data,
        });
        if(data) {
            let statValue: StatValue = {
                name: metric,
                metric: metric,
                date: data.dates[data.dates.length-1],
                value: data.values[data.values.length-1],
                min: Math.min(...data.values),
                max: Math.max(...data.values),
                prevValue: data.values.length > 1 ? data.values[data.values.length-2] : undefined,
                change: undefined,
                changeType: undefined,
                historical: data.values,
                raw: data,
            };

            if(statValue.prevValue) {
                statValue.change = (statValue.value - statValue.prevValue) / statValue.prevValue * 100;
                statValue.changeType = statValue.change  && statValue.change > 0 ? 'increase' : 'decrease';
            }
            console.log("X111623 statValue", statValue)
            return statValue;
        }

        return null;
    }

    return (
         <Widget title={name} showHeader={false} renderActions={() => (<></>)}>
            <Stats year={settings[SETTING_SEASON_YEAR]} dateSelected={dateSelected} loading={dataLoading} metric={name} description={description} data={rawData ? rawData : null} changeInverted={changeInverted} />
        </Widget>
    )
}

export default DwFieldStatWidget;